import * as React from 'react'

import { FallbackImage } from '~/components/parts/FallbackImage'

type Props = {
  src: string
}

export const ProfilePicture: React.FC<Props> = ({ src }) => {
  return (
    <FallbackImage
      boxSize="64px"
      borderRadius="radiiFull"
      alt="Member Image"
      fallbackSrc="/default_profile_picture.png"
      src={src}
    />
  )
}
